const name = "EZBuild"

const generateDocumentTitle = (title: string): void => {
  const result = title ? `${title} - ${name}` : name

  if (document.title === result) return

  document.title = result
}

export { generateDocumentTitle }
